import { trackEvent } from '@web/o11y/analytics'

import { desktopApp } from 'lib/desktop_app'
import initialOptions from 'lib/initial_options'

export function noAuthedUsersSwitchToFileBrowser() {
  if (desktopApp) {
    desktopApp.setLoading(false)
    desktopApp.showFileBrowser()
    console.warn('Not signed in, aborting init!')
    trackEvent('Desktop Logged Out Page Load')
  }
}

/** Bail out of an entry bootstrap if a desktop tab has no signed-in user. */
export function redirectIfNoAuthOnDesktop(): boolean {
  if (desktopApp && !desktopApp.isFileBrowserTab() && !initialOptions().user_data) {
    noAuthedUsersSwitchToFileBrowser()
    return true
  }
  return false
}

export function closeTabAndRedirectToFileBrowser() {
  if (desktopApp) {
    desktopApp.showFileBrowser()
    desktopApp.close({
      suppressReopening: true,
      shouldForceClose: true,
    })
  }
}
